import { commonViewTexts } from '../common';

const targetName = commonViewTexts.koumuten;

export const koumutenListViewTexts = {
  title: `${targetName}一覧`,
  buttons: {
    create: `${targetName}登録`,
    edit: commonViewTexts.edit,
    delete: commonViewTexts.delete
  },
  searchBarPlaceholder: `${targetName}名`,
  header: {
    name: `${targetName}名`,
    numCompanies: `${commonViewTexts.company}数`,
    author: commonViewTexts.author,
    dateCreated: commonViewTexts.dateCreated,
    dateUpdated: commonViewTexts.dateUpdated
  }
} as const;
